<div class="card-header"
     [ngClass]="{ collapsible: isCollapsible, collapsed: collapsed }"
     (click)="toggle()">
    <div class="d-flex gap-2 align-items-center">
        @if (iconClass) {
            <i [ngClass]="iconClass"
               class="flex-shrink-0"
               [adaptTooltip]="iconTooltip"></i>
        }

        <h2 class="mb-0">{{ name }}</h2>

        @if (info) {
            <i class="d-print-none fal fa-circle-info"
               [adaptTooltip]="info"></i>
        }

        @if (isCollapsible && isExpandable) {
            <i class="d-print-none fal {{ collapsed ? 'fa-chevron-down' : 'fa-chevron-up' }}"></i>
        }

        <ng-content select="[adapt-collapsible-header-title]"></ng-content>
    </div>

    <div class="d-print-none ms-lg-auto mt-2 mt-lg-0 d-flex align-items-center gap-3">
        @if (linkText) {
            <div>
                @if (linkObject) {
                    <a [routerLink]="linkObject.path"
                       [queryParams]="linkObject.queryParams"> {{ linkText }} <i class="ms-1 fas fa-arrow-right"></i> </a>
                } @else {
                    @if (hasClickSubscribers) {
                        <span class="clickable-header"
                              (click)="onHeaderClicked()">
                            {{ linkText }}
                            <i class="ms-1 fas fa-arrow-right"></i>
                        </span>
                    }
                }
            </div>
        }

        <ng-content select="[adapt-collapsible-header-action-right]"></ng-content>
    </div>
</div>

@if (isExpandable) {
    <div [class.nested]="nested"
         [collapse]="collapsed"
         [isAnimated]="true"
         class="card-collapse-wrapper">
        <div class="card-body">
            @if (contentCard) {
                <div class="card">
                    <div class="card-body inner-card-body">
                        <ng-container [ngTemplateOutlet]="projectedContent"></ng-container>
                    </div>
                </div>
            } @else {
                <ng-container [ngTemplateOutlet]="projectedContent"></ng-container>
            }
        </div>
    </div>
}

<ng-template #projectedContent>
    <ng-content></ng-content>
</ng-template>
